import React, { Component, MouseEventHandler } from 'react'
import type { RefObject } from 'react'
import { createPortal } from 'react-dom'
import styles from './drawer.module.css'

export interface DrawerOverlayProps {
	isOpen?: boolean
	isModal?: boolean
	closeOnOverlayClick?: boolean
	setOpen?: (isOpen: boolean) => any
	className?: string
	portalClassName?: string
	overlayRef?: RefObject<HTMLElement>
}
interface DrawerState {
	portalEl: HTMLElement | null
}
export default class DrawerOverlay extends Component<DrawerOverlayProps, DrawerState> {
	state = {
		portalEl: null
	}
	componentDidMount() {
		if (typeof window !== 'undefined' && !this.state.portalEl) {
			const portalEl = document.createElement('div')
			portalEl.setAttribute('class', `${styles.drawerPortal} ${this.props.portalClassName || ''}`)
			document.body.appendChild(portalEl)
			this.setState({ portalEl })
		}
	}
	componentDidUpdate(oldProps: DrawerOverlayProps) {
		if (oldProps.portalClassName !== this.props.portalClassName) {
			this.state.portalEl.setAttribute('class', `${styles.drawerPortal} ${this.props.portalClassName || ''}`)
		}
	}
	componentWillUnmount() {
		if (typeof window !== 'undefined' && this.state.portalEl) {
			this.state.portalEl.parentElement.removeChild(this.state.portalEl);
		}
	}
	onOverlayClick: MouseEventHandler = e => {
		const { isModal = false, closeOnOverlayClick = true, setOpen } = this.props
		if (isModal && closeOnOverlayClick && setOpen && this.props.overlayRef.current === e.target) {
      setTimeout(() => setOpen(false), 200)
		}
	}
	render() {
		if (!this.state.portalEl) {
			return null
		}
		const { className = '', children, isOpen, isModal } = this.props
		const clsClickable = isOpen && isModal ? styles.overlayClickable : ''
		return createPortal(
			<div
				className={`${styles.drawerOverlay} ${clsClickable} ${className}`}
				onClick={this.onOverlayClick}
			 	ref={this.props.overlayRef as RefObject<HTMLDivElement>}
			>
				{ children }
			</div>,
			this.state.portalEl
		)
	}
}